<template>
    <div>
        <div class="modal-body">
            <div class="row">
                <div class="col-6">
                    <div class="form-group">
                        <label for="name" class="required">{{t('STEPS.NAME')}}</label>
                        <input :disabled="isView" type="text" id="name" class="form-control" v-model="item.name">
                    </div>
                </div>
                <div class="col-6">
                    <div class="form-group">
                        <label for="name" class="required">{{t('STEPS.ALLOTMENT')}}</label>
                        <select2 :disabled="isView || isEdit" placeholder="Selecione" :options="allotments" :settings="{width:'100%'}" v-model="item.allotment_id"></select2>
                    </div>
                </div>
                <div class="col-6">
                    <div class="form-group">
                        <label for="name">{{t('STEPS.TEMPLATE_PROPOSAL')}}</label>
                        <select2 :disabled="isView" placeholder="Selecione" :options="templates" :settings="{width:'100%'}" v-model="item.template_id"></select2>
                    </div>
                </div>
                <div class="col-6">
                    <div class="form-group">
                        <label for="name">{{t('STEPS.TEMPLATE_CONTRACT')}}</label>
                        <select2 :disabled="isView" placeholder="Selecione" :options="templates" :settings="{width:'100%'}" v-model="item.template_contract_id"></select2>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <div class="btn btn-secondary" @click="close">{{t('ACTIONS.CLOSE')}}</div>
            <div class="btn btn-primary" v-if="!isView" @click="save">{{t('ACTIONS.SAVE')}}</div>
        </div>
    </div>
</template>

<script>
import {useToast} from 'vue-toastification';
import {useI18n} from 'vue-i18n';
import Select2 from 'vue3-select2-component';
import {mapState} from 'vuex';
import Steps from '../../services/Steps';

export default {
    name: "modalCrudComponent",
    props:['isCreate', 'isEdit', 'isView', 'stepIndex','templates'],
    setup() {
        const toast = useToast();
        const {t} = useI18n();
        return {t, toast};
    },
    computed:{
        ...mapState({
            allotments:'allotments',
        })
    },
    components:{
        Select2,
    },
    data(){
        return{
            item:{},
        }
    },
    watch:{
        stepIndex() {
            this.item = this.stepIndex;
        }
    },
    mounted() {
        this.item = this.stepIndex;
    },
    methods:{
        close(){
            document.getElementById('closeX')?.click();
        },
        save(){
            if (!this.item?.name || !this.item?.allotment_id){
                this.toast.error('Preencha todos os campos obrigatórios');
                return;
            }
            this.$store.commit('changeLoading', true);
            if (this.isEdit){
                Steps.edit(this.item.id, this.item).then(() => {
                    this.toast.success(this.t('GENERAL.UPDATED_SUCCESSFULL'));
                    this.$emit('updated');
                }).catch((err) => {
                    this.$store.commit('changeLoading', false);
                    this.errorMsg(err);
                });
            }
            if (this.isCreate){
                Steps.create(this.item).then(() => {
                    this.toast.success(this.t('GENERAL.CREATED_SUCCESSFULL'));
                    this.$emit('updated');
                }).catch((err) => {
                    this.$store.commit('changeLoading', false);
                    this.errorMsg(err);
                });
            }
        }
    }
}
</script>

<style scoped>

</style>